/**
 * Gate de compras por plataforma.
 *
 * A política de billing do Google Play proíbe vender bens/serviços
 * digitais dentro do app por fora do Play Billing — e também proíbe
 * direcionar o usuário pra comprar em outro lugar (anti-steering).
 * Enquanto não integramos Play Billing, o app nativo é "somente uso":
 * mostra plano, consumo e faturas, mas nenhum preço de oferta, pack,
 * picker ou checkout. A web segue vendendo normalmente via Asaas.
 *
 * Tudo que oferece compra deve consultar este helper — o backstop duro
 * fica no BillingCheckoutDialog, que não renderiza no nativo.
 */
import { isNative } from './api-base';

export function purchasesAllowed(): boolean {
  return !isNative();
}
